import { z } from 'zod/v4'

export const schema = z
  .object({
    idCompany: z.string(),
    idProject: z.string().optional(),
    autodeploy: z.boolean(),
    idCluster: z.string(),
    source: z.enum(['app', 'dockerImage', 'privateGit', 'publicGit']),
    gitType: z.enum(['github', 'gitlab', 'bitbucket']).optional(),
    defaultBranch: z.string().optional(),
    idRemoteRepository: z.string().optional(),
    repoUrl: z.url().optional(),
    dockerImage: z.string().optional(),
    idDockerRegistryCredential: z.string().optional(),
    displayName: z.string({ message: 'Name is required' }).min(1, {
      message: 'Name is required',
    }),
    idProcessResourceType: z.string(),
  })
  .refine((val) => !(val.source === 'dockerImage' && !val.dockerImage), {
    message: 'Docker image is required',
    path: ['dockerImage'],
  })
  .refine((val) => !(val.source === 'privateGit' && !val.idRemoteRepository), {
    message: 'Repository is required',
    path: ['idRemoteRepository'],
  })
  .refine((val) => !(val.source === 'publicGit' && !val.repoUrl), {
    message: 'Repository url is required',
    path: ['repoUrl'],
  })
  .refine(
    (val) =>
      !(
        (val.source === 'privateGit' || val.source === 'publicGit') &&
        !val.defaultBranch
      ),
    {
      message: 'Branch is required',
      path: ['defaultBranch'],
    }
  )

export type CreateAppFormValues = z.infer<typeof schema>
